module.exports = __webpack_public_path__ + "img/2-4.ab45b7c8.svg";